/* eslint-disable new-cap */
import React from 'react'
import { useHookstate, type State } from '@hookstate/core'
import { Card, CardHeader, IconButton } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import ManagementInvolvedFilters from '../ManagementQualifiersFilters'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import type {  FilterState, IListDispatchTab, AnimalsFilter } from '~/features/Management/interfaces';
import ChartsAnimals from './components/ChartsAnimal'
import useManagementQualifiersAnimalsState from '~/features/Management/stores/ManagementQualifiersAnimalState'

interface IAnimalsChartProps {
  readonly expandFilterSearch: State<boolean>;
  readonly valueTab?: IListDispatchTab;
  readonly filters: State<FilterState>;
  readonly setFilters: (filters: AnimalsFilter) => void;
  readonly searched: boolean;
  readonly setSearched: (value: boolean) => void;
}

export default function AnimalsChart({
  expandFilterSearch,
  valueTab,
  filters,
  setFilters,
  searched,
  setSearched,
}: IAnimalsChartProps) {
  const { loadingCharts } = useManagementQualifiersAnimalsState()
  const labelButton = useHookstate<string>('Search')
  const { translate } = useLang()

  return (
    <Card
      sx={{
        boxShadow: 4,
        paddingBottom: 2,
        height: expandFilterSearch.value ? 'auto' : 50,
      }}
    >
      <CardHeader
        title={`${translate('Filters')}`}
        avatar={
          <IconButton
            onClick={() => {
              expandFilterSearch.set((item) => !item)
            }}
            sx={{
              display: 'flex',
              justifyContent: 'end',
              marginRight: 1,
            }}
          >
            {expandFilterSearch.value ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        }
        titleTypographyProps={{ fontWeight: 'bold', fontSize: 18 }}
      />
      <ManagementInvolvedFilters
        hidden={expandFilterSearch.get()}
        labelButton={labelButton}
        periodFilter
        typeVehicleFilter
        destinationFinalFilter
        vehicleCiscunstanceFilter
        valueTab={valueTab}
        clearFilters={() => {
          setSearched(false)
        }}
        searchButton={() => {
          setSearched(true)
        }}
        filters={filters}
        setFilters={setFilters}
      />
      {!loadingCharts.get() && searched && (
        <ChartsAnimals expandFilterSearch={expandFilterSearch.get()} />
      )}
    </Card>
  )
}
